'use client' // Error boundaries must be Client Components
 
export default function GlobalError({ error, reset }) {
  return (
    // global-error must include html and body tags
    <html>
      <body>
        <h2>Something went wrong!</h2>
        <p>GlobalError</p>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  )
}